<template>
	<div>
		<div class="block">
			<div class="tag" @click="clickExternalSearch">
				<IconSearchPlus /> {{ $t('song.addSong') }}
			</div>
		</div>
		<div class="block">
			<div class="tag" @click="clickAllSongs">
				{{ $t('song.allSongs') }}
				<span>{{ countAllSongs }}</span>
			</div>
			<div class="tag" @click="clickQueueSongs">
				{{ $t('song.queueSongs') }}
				<span>{{ queueSongs.length }}</span>
			</div>
		</div>
	</div>
</template>

<script>
	import IconSearchPlus from "@/components/icons/IconSearchPlus";
	import { mapState } from "vuex";

	export default {
		components: {
			IconSearchPlus
		},
		computed: {
			...mapState([ "localSearchOpened", "queueSongs" ]),
			countAllSongs() {
				return Object.keys(this.$store.state.songs).length;
			},
		},
		methods: {
			clickAllSongs() {
				this.$store.commit("setRootSideOpened", false);
				this.$store.commit("setExternalSearchOpened", false);
				this.$store.commit("setSongsSorting", false);
				this.$store.commit("setSongsFilter", {
					playlist: null,
					author: null,
					onlyQueue: false
				});
			},
			clickQueueSongs() {
				this.$store.commit("setRootSideOpened", false);
				this.$store.commit("setExternalSearchOpened", false);
				this.$store.commit("setSongsSorting", false);
				this.$store.commit("setSongsFilter", {
					playlist: null,
					author: null,
					onlyQueue: true
				});
			},
			clickExternalSearch() {
				this.$store.commit("setRootSideOpened", false);
				this.$store.commit("setExternalSearchOpened", true);
				this.$store.commit("setSongsSorting", false);
			},
			keydownEvent(e) {
				if (this.localSearchOpened) return;
				if (e.srcElement.tagName === "INPUT" || e.srcElement.tagName === "TEXTAREA") return;
				if (e.code === "KeyA") {
					this.$store.commit("setSideOpened", true);
					this.clickExternalSearch();
				}
			},
		},
		mounted() {
			document.addEventListener("keyup", this.keydownEvent);
		},
		destroyed() {
			document.removeEventListener("keyup", this.keydownEvent);
		}
	}

</script>

<style lang="scss" scoped>
	.block {
		padding-bottom: 20px;
	}

	.icon-search-plus {
		float: left;
		margin: 4px 14px 0 0;
		width: 22px;
		fill: rgba(0, 0, 0, 1);
	}
</style>
